'use strict';
/* ==========================================================================
   levels/song.js — "The Big Drop II", step 4: HOT TO NOT (DESIGN.md §5.5; content/song.json), orientation "any".
   The karaoke of the one ACE-Step take: assets/music/song.m4a (lesson.json preload.stream: played through the shared
   <audio> element, never decoded) + assets/music/song_words.json (tools/song_timing.py: the TRUE lyrics aligned; only
   these words are shown). Behind it, the heat view of a looping scene: The Big Drop's s3 run (HeatKit.coaster, the
   brake run warming from the model) on the case-file page, with its legend and label. The hook's words "on its own"
   are written in red pencil. Stamped when 90 % of the song has been heard (or Finish, then; or the end).
   Without the timings (or the audio) it still works: the lyrics of content/song.json on the page and a Finish button.
   Keys: Space play / pause, R restart, ← → 5 s, Enter (at the end) back to the map. On a phone held upright: the
   portrait dock (Dock.karaoke + the bar's buttons).
   QA: sc.song ({dur, lines}), sc.heard, sc.ended, sc.audioReady, sc.now(), sc.debugAt(t), sc.done(), sc.canFinish().
   ========================================================================== */
(function () {
  const STEP = 'song';
  const AUDIO = 'music/song.m4a', WORDS = 'music/song_words.json', KEY = 'song:heat';
  const FINISH_AT = 0.9, CREDIT = 'AI-generated song · the physics is real';
  const BAND_Y = 800, CUR_Y = 900, NEXT_Y = 990;
  const RUN = Tracks.get('s3'), RUN_T = (RUN.sim.tSettle || 16) + 3;

  const HOOK = /^(on|its|own[,.!]?)$/i;
  function hookIdx(line) {                            // the words of "on its own" in a line (a hook line)
    const out = new Set(), w = line.words;
    for (let j = 0; j + 2 < w.length; j++) if (/^on$/i.test(w[j].w) && /^its$/i.test(w[j + 1].w) && /^own/i.test(w[j + 2].w)) { out.add(j); out.add(j + 1); out.add(j + 2); }
    return out;
  }
  /* the line on show at song time t: the line being sung (t inside its [s, e)); between lines, the next one from 0.15 s
     before it starts, else the last one for 0.6 s after it ends. A line never hands over while one of its words is
     still being sung (tools/qa_song.js proves it over the whole song) */
  const lyricAt = (S, t) => {
    const L = S.lines;
    let k = -1;
    for (let i = 0; i < L.length; i++) if (t >= L[i].s && t < L[i].e) { k = i; break; }
    if (k < 0) {
      const n = L.findIndex(l => l.s > t), p = n < 0 ? L.length - 1 : n - 1;
      if (n >= 0 && t >= L[n].s - 0.15) k = n;
      else if (p >= 0 && t < L[p].e + 0.6) k = p;
    }
    const cur = k >= 0 ? L[k] : null;
    const next = k >= 0 ? L[k + 1] || null : L.find(l => l.s > t + 0.05) || null;
    return { cur, next };
  };


  class Song extends Scene {
    enter() {
      this.song = null; this.err = null; this.playing = false; this.ended = false; this.frozen = false; this.startedOnce = false;
      this.pos = 0; this.t0ctx = null; this.heard = 0; this.audioReady = false; this.completed = false; this.gone = false;
      Audio.stopMusic(); HeatKit.load();
      const wurl = Assets.url(WORDS);
      const words = (window.Loader ? Loader.json(wurl).then(d => d || Promise.reject(new Error('no timings'))) : fetch(wurl).then(r => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)))))
        .then(d => { if (!d || !Array.isArray(d.lines) || !d.lines.length) throw new Error('empty timings'); this.song = { dur: d.duration || d.lines[d.lines.length - 1].e + 2, lines: d.lines.filter(l => l.words && l.words.length) }; })
        .catch(e => { this.err = String(e && e.message); console.warn('[song] no timings', this.err); });
      const audio = (Audio.has(KEY) ? Promise.resolve() : Audio.load({ [KEY]: Assets.url(AUDIO) })).then(() => { this.audioReady = Audio.has(KEY); }, e => { console.warn('[song] no audio', e && e.message); });
      Promise.all([words, audio]).then(() => { if (!this.gone && !this.frozen && !this.startedOnce && this.song) this.play(0); });
      if (window.Device) {
        this.onHidden = Device.on('hidden', () => { if (this.playing && !this.gone) { this.pause(); this.resumeOnReturn = true; } });
        this.onResume = Device.on('resume', () => { if (this.resumeOnReturn && !this.gone && Game.current() === this) { this.resumeOnReturn = false; this.play(this.pos); } });
      }
    }
    exit() {
      this.gone = true; this.playing = false; Audio.stopGroup('song');
      if (this.media) this.media.pause();
      if (window.Device) { Device.off('hidden', this.onHidden); Device.off('resume', this.onResume); }
    }
    back() { Game.replace(new Levels.map()); }
    now() {
      if (this.playing && this.t0ctx != null) {
        const m = this.media;
        if (m) return m.playing() ? m.time() : m.el && m.el.ended ? this.song.dur : this.pos;
        if (Audio.running()) return Audio.now() - this.t0ctx;
      }
      return this.pos;
    }
    play(from = this.now()) {
      if (!this.song) return;
      this.startedOnce = true; this.frozen = false; this.ended = false;
      from = clamp(from, 0, this.song.dur - 0.05);
      Audio.stopGroup('song');
      this.pos = from; this.playing = true; this.t0ctx = null;
      if (!this.audioReady || window.__timeScale > 1) return;
      this.media = this.media || Audio.media(KEY);
      if (this.media) {
        const m = this.media, tok = this.playTok = (this.playTok || 0) + 1;
        this.playAt = Game.time; this.blocked = false;
        m.play(from).then(ok => {
          if (tok !== this.playTok || this.gone) return;
          if (ok && this.playing) { this.pos = m.time(); this.t0ctx = 0; } else if (!ok) { this.pause(); this.blocked = true; }
        });
      } else if (Audio.running()) {
        const at = Audio.now() + 0.06;
        Audio.schedule(KEY, { at, offset: from, gain: 1, group: 'song', bus: 'voice', fade: 0.03 });
        this.t0ctx = at - from;
      }
    }
    pause() { this.pos = this.now(); this.playing = false; this.t0ctx = null; this.playTok = (this.playTok || 0) + 1; Audio.stopGroup('song'); if (this.media) this.media.pause(); }
    toggle() { if (this.playing) this.pause(); else this.play(this.ended ? 0 : this.pos); Audio.play('paper', { gain: 0.25 }); }
    seek(t) { if (!this.song) return; const was = this.playing; this.pause(); this.pos = clamp(t, 0, this.song.dur); this.ended = false; if (was) this.play(this.pos); }
    restart() { this.heard = 0; this.play(0); }
    debugAt(t) { this.pause(); this.frozen = true; this.startedOnce = true; this.ended = false; this.pos = t; }
    done() { if (this.completed) return; this.completed = true; this.pause(); if (!Game.progress.stamps[STEP]) Game.complete(STEP); }
    canFinish() { return !this.completed && (!this.song ? !!this.err : this.heard >= FINISH_AT * this.song.dur); }
    finish() { if (this.canFinish()) { Audio.play('stamp_case', { gain: 0.7 }); this.done(); } }

    update(dt) {
      if (!this.song || !this.playing) return;
      if (this.t0ctx == null) {
        this.pos += dt * (window.__timeScale || 1);
        const retry = this.audioReady && !(window.__timeScale > 1) && (this.media ? !this.blocked && Game.time - (this.playAt || 0) > 3 : Audio.running());
        if (retry) this.play(this.pos);
      }
      this.heard += dt * (this.t0ctx == null ? (window.__timeScale || 1) : 1);
      if (this.now() >= this.song.dur - 0.05) {
        this.pause(); this.pos = this.song.dur; this.ended = true;
        if (!this.completed && this.heard >= FINISH_AT * this.song.dur) this.done();
      }
    }
    keyDown(k) {
      if (!this.song) { if (k === 'Enter') this.finish(); return; }
      if (k === ' ') this.toggle();
      else if (k === 'r' || k === 'R') this.restart();
      else if (k === 'ArrowRight') this.seek(this.now() + 5);
      else if (k === 'ArrowLeft') this.seek(this.now() - 5);
      else if (k === 'Enter') { if (this.ended) this.back(); else this.finish(); }
    }
    pointerDown(x, y) {
      if (!this.song || this.ended || UI.inHud(x, y, 3)) return;
      if (UI.docked()) { this.toggle(); return; }
      if (this._finBox && Math.abs(x - this._finBox.x) < this._finBox.w / 2 && Math.abs(y - this._finBox.y) < this._finBox.h / 2) return;
      if (y < BAND_Y) this.toggle();
    }

    /* ---------- the picture: the heat view of the s3 run, looping on the song clock ---------- */
    picture(t, docked) {
      const title = (Game.content.song && Game.content.song.title) || 'Hot to Not';
      HeatKit.skin.ground();
      const r = { x: 120, y: 200, w: 1180, h: 520 };
      paperRect(r.x + r.w / 2, r.y + r.h / 2 + 12, r.w + 40, r.h + 60, '#fffdf7', { seed: 1601, depth: 1.4, boil: false });
      HeatKit.coaster(r, { t: t % RUN_T, heat: true });
      HeatKit.drawPart('clip', r.x + r.w - 70, r.y - 30, 0.12, 1.2);       // top right: clear of the credit line
      const lg = HeatKit.legend(1360, 200, HeatKit.scale('station'), { w: 420 });
      const cy = lg.y + lg.h + 16;
      HeatKit.chart(1350, cy, 440, Math.max(220, 770 - cy), t % RUN_T);
      ransom(title.toUpperCase(), 44, 74, 48, this.enteredAt + 0.1, { align: 'left', seed: 515 });
      HeatKit.text(CREDIT, 48, 140, 24, { color: '#5b4a3a' });
    }
    /* ---------- the karaoke band: the line being sung, its words lighting up; the next line faint ---------- */
    band(t) {
      paperRect(960, (BAND_Y + 1080) / 2, 1920, 1080 - BAND_Y, '#fbf3df', { seed: 1602, depth: 1, boil: false });
      const { cur, next } = lyricAt(this.song, t);
      const fs = Math.round(UI.text(60)), nfs = Math.round(UI.text(36));
      if (cur) {
        const hk = hookIdx(cur), sp = HeatKit.tw(' ', fs, 'hand'), widths = cur.words.map(w => HeatKit.tw(w.w, fs, 'hand'));
        const tot = widths.reduce((a, b) => a + b, 0) + sp * (widths.length - 1), sc = Math.min(1, 1800 / tot);
        let x = 960 - tot * sc / 2;
        cur.words.forEach((w, j) => {
          const sung = t >= w.s, col = hk.has(j) ? '#c0392b' : sung ? '#2b2420' : '#a8987e';
          HeatKit.text(w.w, x, CUR_Y, Math.round(fs * sc), { face: 'hand', color: col });
          if (sung && t < w.e + 0.15) { g.save(); g.fillStyle = 'rgba(242,193,78,0.45)'; g.fillRect(x - 4, CUR_Y + fs * 0.35 * sc, widths[j] * sc + 8, 8); g.restore(); }
          x += (widths[j] + sp) * sc;
        });
      }
      if (next) HeatKit.text(next.text, 960, NEXT_Y, nfs, { align: 'center', color: '#8a7a66' });
      if (!cur && !next) HeatKit.text('Hot to not, on its own.', 960, CUR_Y, fs, { face: 'hand', align: 'center', color: '#c0392b' });
      // the strip: position in the song
      g.save(); g.fillStyle = '#b9a77f'; g.fillRect(0, 1070, 1920, 10); g.fillStyle = '#2b2420'; g.fillRect(0, 1070, 1920 * t / this.song.dur, 10); g.restore();
    }
    /* the song's lyrics on the page (no timings): content/song.json, sections dropped */
    sheet() {
      const S = Game.content.song, lines = S && S.lyrics ? S.lyrics.split('\n').filter(l => l.trim() && !/^\[/.test(l.trim())) : [];
      const cols = 2, per = Math.ceil(lines.length / cols), fs = Math.round(UI.text(30));
      lines.forEach((l, i) => HeatKit.text(l, 140 + Math.floor(i / per) * 860, 250 + (i % per) * fs * 1.45, fs, { face: 'hand', color: /on its own/i.test(l) ? '#c0392b' : '#2b2420' }));
    }

    draw() {
      const docked = UI.docked(), title = (Game.content.song && Game.content.song.title) || 'Hot to Not';
      if (!this.song) {
        HeatKit.skin.ground();
        ransom(title.toUpperCase(), 44, 74, 48, this.enteredAt + 0.1, { align: 'left', seed: 515 });
        if (this.err) this.sheet();
        else HeatKit.text('warming up the band…', 960, 520, 44, { align: 'center', color: '#5b4a3a' });
        if (docked) { Dock.head(title, ''); Dock.text('sg-wait', [this.err ? 'The song is missing. Here are the words.' : 'warming up the band…'], { cls: 'note center' }); }
        this.chrome(null, docked);
        return;
      }
      const t = clamp(this.now(), 0, this.song.dur);
      this.picture(t, docked);
      if (!docked) this.band(t);
      this.chrome(t, docked);
    }
    chrome(t, docked) {
      if (docked) {
        const S = this.song, mmss = s => Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');
        Dock.head((Game.content.song && Game.content.song.title) || 'Hot to Not', S && t != null ? `${mmss(t)} / ${mmss(S.dur)}` : '');
        if (S && t != null) {
          const { cur, next } = lyricAt(S, t);
          if (cur) {
            const key = cur.i + ':' + cur.s, hk = hookIdx(cur);
            if (!this._dk || this._dk.key !== key) this._dk = { key, words: cur.words.map((w, j) => ({ w: w.w, s: w.s, e: w.e, hook: hk.has(j) })) };
            Dock.karaoke({ key, words: this._dk.words, t, next: next ? next.text : '', section: (cur.section || '').toLowerCase() });
          } else Dock.karaoke({ key: 'gap', words: [], t, next: next ? next.text : '', section: '', note: this.startedOnce ? '♪ ♫ ♪' : 'loading the song…' });
          Dock.text('credit', [CREDIT], { cls: 'small center' });
          Dock.button({ id: 'restart', glyph: '↺', label: 'restart', aria: 'play the song from the start', onClick: () => this.restart() });
          Dock.button({ id: 'play', glyph: this.playing ? '❚❚' : '▶', label: this.playing ? 'pause' : 'play', aria: this.playing ? 'pause' : 'play', primary: true, onClick: () => this.toggle() });
        }
        if (this.canFinish()) Dock.buttons('sg-fin', [{ label: 'Finish', onClick: () => this.finish() }]);
        if (this.ended && Game.current() === this) Dock.buttons('sg-end', [{ label: 'Play it again', onClick: () => this.restart() }, { label: 'Back to the map', onClick: () => this.back() }]);
        Dock.button({ id: 'map', glyph: '⌂', label: 'map', aria: 'back to the map', onClick: () => this.back() });
        return;
      }
      const m = UI.hudSlot(0), pl = UI.hudSlot(1), fx = { r: m.r, fixed: true };
      if (UI.iconButton('sg-map', '⌂', m.x, m.y, fx)) { this.back(); return; }
      if (this.song) {
        const hp = UI._hit('b:sg-play', pl.x, pl.y, pl.r * 2, pl.r * 2);
        paperCircle(pl.x, pl.y, pl.r, '#e0533d', { seed: 1610, depth: hp.pressed ? 0.4 : 1, boil: false });
        g.save(); g.fillStyle = '#fbf5e6'; g.translate(pl.x, pl.y); const s = pl.r * 0.4;
        if (this.playing) { g.fillRect(-s * 0.9, -s, s * 0.6, s * 2); g.fillRect(s * 0.3, -s, s * 0.6, s * 2); } else { g.beginPath(); g.moveTo(-s * 0.6, -s); g.lineTo(s, 0); g.lineTo(-s * 0.6, s); g.closePath(); g.fill(); }
        g.restore();
        if (hp.clicked) this.toggle();
      }
      this._finBox = null;
      if (this.canFinish() && !this.ended) {
        const w = UI.tap(250), h = UI.tap(84), fy = m.y + m.r + 30 + h / 2, fxp = m.x + m.r - w / 2;
        this._finBox = { x: fxp, y: fy, w, h };
        if (UI.button('sg-finish', 'Finish', fxp, fy, { w, h, size: UI.text(40), color: '#c0392b' })) { this.finish(); return; }
      }
      if (this.song && !this.playing && !this.frozen && this.startedOnce && !this.ended) HeatKit.text(UI.hint('paused · click or Space to play', 'paused · tap to play'), 700, 470, 44, { align: 'center', outline: '#fbf3df' });
      if (this.ended && Game.current() === this) {
        if (UI.button('sg-again', 'Play it again', 600, 470, { w: 440, h: 110, size: 46, color: '#f2c14e', text: '#2b2420' })) this.restart();
        if (UI.button('sg-back', 'Back to the map', 1100, 470, { w: 440, h: 110, size: 46, color: '#c0392b' })) this.back();
      }
    }
  }
  Song.STEP = STEP;
  Song.KEY = KEY;
  Song.lyricAt = lyricAt;                    // QA (tools/qa_song.js)
  Levels.song = Song;
})();
